import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { ButtonComponent } from '../../common/button/button.module';
import { DropdownModule } from '../../common/dropdown/dropdown.module';
import { SegmentedControlModule } from '../../common/segmented-control/segmented-control.module';
import { TimeZonePickerModule } from '../time-zone-picker/time-zone-picker.module';
import { GroupComponent } from './../../common/group/group.module';
import { IconComponent } from './../../common/icon/icon.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { DatePickerModule } from './../../forms/date-picker/date-picker.module';
import { InputModule } from './../../forms/input/input.module';
import { TimePickerDropdownModule } from './../../forms/time-picker/time-picker-dropdown/time-picker-dropdown.module';
import { TimePickerBridge } from './time-picker-moment-bridge/time-picker-moment-bridge';
import { TimePickerComponent, TimeData } from './time-picker.component';

@NgModule({
  declarations: [TimePickerComponent],
  exports: [TimePickerComponent],
  imports: [
    GroupComponent,
    ButtonComponent,
    IconComponent,
    I18nModule,
    CommonModule,
    DatePickerModule,
    InputModule,
    RtUICoreOverlayModule,
    TimePickerDropdownModule,
    TimeZonePickerModule,
    SegmentedControlModule,
    DropdownModule,
  ],
})
export class TimePickerModule {}
export { TimePickerComponent, TimeData, TimePickerBridge };
